export function getColorState(statoSanzione) {
  var result = "";
  switch (statoSanzione) {
    case "Caricato":
      result = "Gold";
      break;
    case "Validato":
      result = "CornflowerBlue";
      break;
    case "Ingiunzione":
      result = "FireBrick";
      break;
    case "Attesa Periodo":
      result = "orange";
      break;
    default:
      result = "black";
  }
  return result;
}

export function geDataFormat(data) {
  var moment = require("moment");
  return moment(data).format("DD/MM/YYYY");
}
export function geDataFormatFirst(data) {
  var moment = require("moment");
  return moment(data).startOf('month').format("DD/MM/YYYY");
}
export function getFormatOraInput(data) {
  var moment = require("moment");
  // moment.locale("it");
  return moment(data).format("YYYY-MM-DD");
}
export function getFormatForFile(data) {
  var moment = require("moment");
  // moment.locale("it");
  return moment(data).format("DD-MM-YYYY");
}

export function getFormatDataEOra(data) {
  var moment = require("moment");
  // moment.locale("it");
  return moment(data).format("DD/MM/YYYY - HH:mm");
}


export function getFormatOraInputFirst(data) {
  var moment = require("moment");
  // moment.locale("it");
  return moment(data).startOf('month').format('YYYY-MM-DD');
}

export function getFormatInputFirstYear(data){
  var moment = require("moment");

  return moment(data).startOf('year').format('YYYY-MM-DD')
}

export function getFormatOraInputFirstaddMont(data,mont) {
  var moment = require("moment");
  // moment.locale("it");
  var j = moment(data).startOf('month');
  var s = j.add(mont,"M")
  return s.toJSON();
}
export function getFormatOraInputEnd(data) {
  var moment = require("moment");
  // moment.locale("it");
  return moment(data).endOf('month').format('YYYY-MM-DD');;
}

export function calculateTimeDifferenceTwoDates(date2, date1) {
  //alert(date1);
  var Difference_In_Time = date2.getTime() - date1.getTime();
  //alert(Difference_In_Time / (1000 * 3600 * 24))
  return Difference_In_Time / (1000 * 3600 * 24);
}

export const validEmail = new RegExp(
  // "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
  // "[a-z0-9]+@[a-z]+\.[a-z]{2,3}"
  "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]$"
);
// "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$" almeno un maiuscola alemno un numero almeno una minuscalo da 8 a 32 caratteri
export const validPassword = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$");
export const validCF = new RegExp("^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$");
export const validDate = new RegExp("^(((0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02)[-/]?[0-9]{4}|29[-/]?02[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$");
export const validNumbersInput = new RegExp('^[0-9]$');


export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


export function logOut(){
  localStorage.clear();
  window.location.href = "#";
}